import { ridSegment } from '@krp/client-runtime'

/**
 * Адреса импорта накладных native-контракта 1С v1 (срез B3a):
 * `/api/onec/v1/resources/{rid}/import/…`. Литерал `/api/` законен только здесь.
 */
const base = (resourceId: string) => `/api/onec/v1/resources/${ridSegment(resourceId)}/import`
const part = (value: string) => encodeURIComponent(value)

export const ONEC_IMPORT_URLS = {
  invoice: (resourceId: string) => `${base(resourceId)}/invoice`,
  file: (resourceId: string, fileId: string) => `${base(resourceId)}/files/${part(fileId)}`,
  download: (resourceId: string, fileId: string) => `${base(resourceId)}/files/${part(fileId)}/download`,
  mapping: (resourceId: string, fileId: string) => `${base(resourceId)}/files/${part(fileId)}/mapping`,
  validate: (resourceId: string, fileId: string) => `${base(resourceId)}/files/${part(fileId)}/validate`,
  report: (resourceId: string, fileId: string) => `${base(resourceId)}/files/${part(fileId)}/report`,
  reportCsv: (resourceId: string, fileId: string) => `${base(resourceId)}/files/${part(fileId)}/report.csv`,
  profiles: (resourceId: string) => `${base(resourceId)}/profiles`,
  profile: (resourceId: string, profileId: string) => `${base(resourceId)}/profiles/${part(profileId)}`,
} as const
